// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itinerary-table-wrapper .itinerary-table-row .day-col {
  min-width: 90px;
  padding: 0 10px;
  border-right: 1px solid #3a3a3a;
}
.itinerary-table-wrapper .itinerary-table-row .event-wrapper {
  min-width: 180px;
}
.itinerary-table-wrapper .itinerary-table-row .day-col, .itinerary-table-wrapper .itinerary-table-row .transit-event {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: #3a3a3a;
}
.itinerary-table-wrapper .itinerary-table-row .transit-event-date {
  font-size: 14px;
  font-weight: 400;
  color: #7A7A7A;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ItineraryInfoModal/ItineraryTable/style.scss"],"names":[],"mappings":"AAEI;EACE,eAAA;EACA,eAAA;EACA,+BAAA;AADN;AAII;EACE,gBAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAHN;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAJN","sourcesContent":[".itinerary-table-wrapper {\n  .itinerary-table-row {\n    .day-col{\n      min-width: 90px;\n      padding: 0 10px;\n      border-right: 1px solid #3a3a3a;  \n    }\n\n    .event-wrapper{\n      min-width: 180px;\n    }\n\n    .day-col, .transit-event {\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0.03em;\n      color: #3a3a3a;\n    }\n\n    .transit-event-date{\n      font-size: 14px;\n      font-weight: 400;\n      color: #7A7A7A;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
